<script>
	import Router from 'svelte-spa-router'; 
	import { TipoEvento } from '../utils';
	import { sAlgumRecursoCarregando } from '../stores';
	import routes from '../rotas';
	import Carregando from '../componentes/Carregando.svelte';
	import Modal from '../componentes/Modal.svelte';
	
	let exibirModal, estaCarregando = false;
	let mensagemCarregando;
	let dadosModal = {};

	const handleFecharModalEvent = () => exibirModal = false;

	/**
	 * captura o evento dos componentes internos e decide qual evento repassar pro componente pai
	 * eventos mais internos são disparados com tipo específico, o evento genérico routeEvent é 
	 * sempre disparado, o tipo específico deve ser informado para ser capturado dentro de event.detail
	 */
	function routeEvent(event) {
		event.preventDefault();
		let ed = event.detail;

		switch (ed.tipo) {
			case TipoEvento.ESTA_CARREGANDO:
				estaCarregando = Boolean(ed.valor);
				mensagemCarregando = ed.mensagem;
				$sAlgumRecursoCarregando = estaCarregando;
				break;
			case TipoEvento.ABRIR_MODAL:
				exibirModal = true;
				dadosModal.titulo = ed.titulo;
				dadosModal.conteudo = ed.conteudo;
				dadosModal.link = ed.link;
				dadosModal.larguraMaxima = ed.larguraMaxima;
				dadosModal.habilitarCopiarConteudo = ed.habilitarCopiarConteudo;
				break;
			case TipoEvento.FECHAR_MODAL:
				exibirModal = false;
				dadosModal.titulo = '';
				dadosModal.conteudo = '';
				dadosModal.link = '';
				break;
			default:
				console.log('evento desconhecido não encaminhado...');
		}
	}
</script>

{#if estaCarregando}
<Carregando mensagem={mensagemCarregando} />
{/if}

{#if exibirModal}
<Modal 
	titulo={dadosModal.titulo} 
	link={dadosModal.link} 
	larguraMaxima={dadosModal.larguraMaxima}
	habilitarCopiarConteudo={dadosModal.habilitarCopiarConteudo}
	on:fecharModalEvent={handleFecharModalEvent}>
	{@html dadosModal.conteudo}
</Modal>
{/if}

<Router {routes} on:routeEvent={routeEvent} />